import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"

import Swal from "sweetalert2";

import Modal from 'react-bootstrap/Modal';

import { getCategory } from '../../Services/Category'
import { getProduct } from '../../Services/Product'
import { getCart, addToCart } from '../../Services/Cart'

import { defaultProduct } from "../..//Constant/index";

import Header from "../../Components/header";
import Footer from "../../Components/footer";
import BannerSlider from "../../Components/slider/slider";
import "../../assets/css/style.scss";
import banner from "../../assets/images/grocery-web-banner.jpg";
import product1 from "../../assets/images/product-1.png";
import product2 from "../../assets/images/product-2.png";
import product3 from "../../assets/images/product-3.png";
import product4 from "../../assets/images/product-4.png";
import cartIcon from "../../assets/images/cart-icon.svg";
import storeBanner from "../../assets/images/product-banner-store.jpg";
import loadingCart from "../../assets/images/loading-cart.gif";
import postDiscount1 from "../../assets/images/promotion-banner-1.jpg";
import postDiscount2 from "../../assets/images/promotion-banner-2.jpg";


import Login from '../../Components/Login'

import { vendor } from "../../Constant"

import { setCart } from "../../Redux/Slice/cartSlice"

import { TailSpin } from 'react-loader-spinner'
import { useNavigate } from "react-router-dom";
import { Slider } from "@chakra-ui/react";



const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cart } = useSelector((state) => state)

  const [ToggleState, setToggleState] = useState(1);
  const [categories, setCategories] = useState([]);
  const [activeIndex, setActiveIndex] = useState('All');
  const [selectedcategory, setselectedCategory] = useState('All');
  const [products, setProducts] = useState([]);
  const [carts, setCarts] = useState({

  });
  const [productsLoading, setProductsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loginShow, setLoginShow] = useState(false);
  const [productCount, setProductCount] = useState(1);
  const [productDetails, setProductDetails] = useState({

  });


  useEffect(() => {
    // dispatch(setCart([{test: 1}]))
    getProductData()
  }, [selectedcategory])

  useEffect(() => {
    getCategoryData()
    if (!localStorage.getItem("ownezzy-user-loggedIn")) return
    getCartData()
  }, [localStorage.getItem("ownezzy-user-loggedIn")])

  let getCategoryData = async () => {
    const response = await getCategory();
    setCategories(response.data)
  }

  let getProductData = async () => {
    setProductsLoading(true)
    const response = await getProduct(selectedcategory);
    setProducts(response.data.products.reverse())
    setProductsLoading(false)
  }

  let getCartData = async () => {
    setProductsLoading(true)
    const response = await getCart();
    dispatch(setCart(response.data))
    setProductsLoading(false)
  }


  const handeleCategory = (index) => {
    if (index == 'All') {
      setselectedCategory('All');
      setActiveIndex('All')
    } else {
      setselectedCategory(categories[index]._id);
      setActiveIndex(index)
    }
  };

  const getActiveClass = (index, className) =>
    ToggleState === index ? className : "";

  const handleCloseModal = () => {
    setProductCount(1)
    setShowModal(false);
  } 
  const handleShowModal = () => setShowModal(true);

  const onAddToCart = async (val, quantity) => {
    if (localStorage.getItem('ownezzy-user-loggedIn')) {
      let payload = {
        vendor: vendor,
        productId: val._id,
        quantity: quantity,
        cart:
        {
          "prices": val.prices,
          "image": val.image,
          "_id": val._id,
          "title": val.title.en,
          "description": val.description,
          "category": val.category,
          "price": val.prices.price,
          "originalPrice": val.prices.originalPrice,
          "discount": val.prices.discount,
          "quantity": quantity,
          "itemTotal": val.prices.price * quantity

        }

      }

      const response = await addToCart(payload);
      if (response.status == 200) {
        getCartData()
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Item added to cart',
          showConfirmButton: false,
          timer: 1500,
          heigth: '100px'
        })
      }

      else {

      }
    } else {
      setLoginShow(true)
    }
  }

  const gotoProducts = () => {
    navigate("/products")
  }
  const onProductClick = (val) => {
    console.log("val -->", val)
    let obj = {
      title: val.title.en,
      description: val.description.en,
      image: val.image[0],
      orignalPrice: val.prices.originalPrice,
      price: val.prices.price
    }
    setProductDetails(val)
    setShowModal(true)
  }

  let addProduct = () => {
    setProductCount(productCount + 1)
  }
  let removeProduct = () => {
    if (productCount < 2) {
      return
    }
    setProductCount(productCount - 1)
  }


  return (
    <>
      <div className="wrapper">
        <Header />
        <Login loginShow={loginShow} setLoginShow={setLoginShow} />
        <div className="banner-slide">
          {/* <div className="banner-items text-center"><img src={banner} className="w-100" /></div> */}
          <BannerSlider />
        </div>
        <div className="discount--post-wapper">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="box-discweb-items blurbg-color mb-4">
                  <img src={postDiscount1} alt="Discount" />
                  <div className="middle-boxarea-wap">
                    <span className="small-txt-offer">Special Offer</span>
                    <h3 className="title-webtxt-head">Fresh grocery vegetables & fruits </h3>
                    {/* <h6 className="txt-itemweb-rt">Get Upto 30% Off</h6> */}
                    <div className="shop-btndisc">
                      <button type="button" className="btn btn-shopnow">Order Now</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="box-discweb-items ornagebg-color mb-4">
                  <img src={postDiscount2} alt="Discount" />
                  <div className="middle-boxarea-wap">
                    <span className="small-txt-offer">Special Offer</span>
                    <h3 className="title-webtxt-head">Meat & fish all delivery to doorstep</h3>
                    {/* <h6 className="txt-itemweb-rt">Get Upto 30% Off</h6> */}
                    <div className="shop-btndisc">
                      <button type="button" className="btn btn-shopnow">Order Now</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="product-list-wigits">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="heading-product text-center mb-4 mb-md-5">
                  <h2 className="heading-title">Trending Now</h2>
                </div>
              </div>
            </div>
            <div className="row">
              {
                //productsLoading?  <img src = {loadingCart} /> :
                products && products.slice(0, 4).map((val, i) => {
                  return (
                    <div className="col-6 col-md-3 pd-column">
                      <div className="product-box-elemnt">
                        <div onClick={() => onProductClick(val)} className="product-content-area">
                          <div className="img-product-mt">
                            <img src={val.image.length ? val.image[0] : defaultProduct} alt="" />
                          </div>
                          <div className="product-disc-wt">
                            <h3 className="product-title-item">{val.title.en}</h3>
                            <div className="product-price">
                              {
                                val.prices.originalPrice != val.prices.price ?
                                  <span className="cross-price">₹{val.prices.originalPrice}</span>

                                  : null
                              }
                              <span className="actual-price">₹{val.prices.price}</span>
                            </div>
                          </div>
                        </div>
                        <div onClick={() => onAddToCart(val, 1)} className="add-cart-btn mt-2 mt-md-3 px-2 px-lg-3 pb-3"><button type="button" className="btn btn-theme btn-cart-btn"><img src={cartIcon} alt="" />Add To Cart</button></div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className="product-list-wigits">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="multi-products-elements">
                  <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                    <div className="heading-product">
                      <h2 className="heading-title">Popular Products</h2>
                    </div>
                    <div className="product-tab-items">
                      <ul className="tab-menu-bar mb-0">
                        <li onClick={() => handeleCategory('All')} className={`tabs-nav-menu ${activeIndex == 'All' ? 'active' : ''}`}>
                          <button type="button" className={`tabs-nav-link active-tabs`}
                          // onClick={() => toggleTab(1)}
                          >{'All'}</button>
                        </li>
                        {
                          categories && categories.map((val, i) => {
                            return (
                              <li key={i} onClick={() => handeleCategory(i)} className={`tabs-nav-menu ${activeIndex == i ? 'active' : ''}`}>
                                <button type="button" className={`tabs-nav-link ${getActiveClass(1, "active-tabs")}`}
                                //  onClick={() => toggleTab(1)}
                                >{val.name.en}</button>
                              </li>
                            )
                          })
                        }
                        <li onClick={() => gotoProducts()} className={`tabs-nav-menu ${activeIndex == 'All' ? 'active' : ''}`}>
                          <button type="button" className={`tabs-nav-link active-tabs`} style={{ backgroundColor: "#FF5722" }}
                          // onClick={() => toggleTab(1)}
                          >{'More'}</button>
                        </li>

                      </ul>
                    </div>
                  </div>
                  <div className="product-wigit-wrapper">
                    <div className="tabs-container">
                      <div className={`tabs-panel-wap ${getActiveClass(1, "show")}`}>
                        <div className="element-gridproduct">
                          <div className="row">
                            {
                              productsLoading ?
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5%', marginBottom: '5%' }}>
                                  <TailSpin
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    ariaLabel="tail-spin-loading"
                                    radius="1"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={true}
                                  />
                                </div>
                                :
                                products && products.map((val, i) => {
                                  return (
                                    <div className="col-6 col-md-3 pd-column">
                                      <div className="product-box-elemnt">
                                        <div onClick={() => onProductClick(val)} className="product-content-area">
                                          <div className="img-product-mt">
                                            <img src={val.image.length ? val.image[0] : defaultProduct} alt="" />
                                          </div>
                                          <div className="product-disc-wt">
                                            <h3 className="product-title-item">{val.title.en}</h3>
                                            <div className="product-price">
                                              {
                                                val.prices.originalPrice != val.prices.price ?
                                                  <span className="cross-price">₹{val.prices.originalPrice}</span>

                                                  : null
                                              }
                                              <span className="actual-price">₹{val.prices.price}</span>
                                            </div>
                                          </div>
                                        </div>
                                        <div onClick={() => onAddToCart(val, 1)} className="add-cart-btn mt-2 mt-md-3 px-2 px-lg-3 pb-3"><button type="button" className="btn btn-theme btn-cart-btn"><img src={cartIcon} alt="" />Add To Cart</button></div>
                                      </div>
                                    </div>
                                  )
                                })


                            }

                          </div>
                        </div>
                      </div>

                      <div className={`tabs-panel-wap ${getActiveClass(6, "show")}`}>
                        <div className="element-gridproduct">
                          <div className="row">
                            <div className="col-12 col-md-3">
                              <div className="product-box-elemnt">
                                <div className="img-product-mt">
                                  <img src={product3} alt="" />
                                </div>
                                <div className="product-disc-wt">
                                  <h3 className="product-title-item">Seeds of Change Organic Red Rice</h3>
                                  <div className="product-price">
                                    <span className="cross-price">₹75.00</span><span className="actual-price">₹59.00</span>
                                  </div>
                                  <div className="add-cart-btn mt-3"><button type="button" className="btn btn-theme btn-cart-btn"><img src={cartIcon} alt="" />Add To Cart</button></div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-3">
                              <div className="product-box-elemnt">
                                <div className="img-product-mt">
                                  <img src={product1} alt="" />
                                </div>
                                <div className="product-disc-wt">
                                  <h3 className="product-title-item">Seeds of Change Organic Red Rice</h3>
                                  <div className="product-price">
                                    <span className="cross-price">₹75.00</span><span className="actual-price">₹59.00</span>
                                  </div>
                                  <div className="add-cart-btn mt-3"><button type="button" className="btn btn-theme btn-cart-btn"><img src={cartIcon} alt="" />Add To Cart</button></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="banner-store py-4 py-md-5">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="">
                  <img src={storeBanner} className="w-100 border-radius" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showModal}
          onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Product Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="detail-view-wrapper py-md-4">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="dtl--aside--product">
                    <div className="product-img-dtls mb-3 mb-lg-5">
                      <img src={productDetails.image &&  productDetails.image.length ? productDetails.image[0] : defaultProduct} alt="" />
                    </div>
                    <div className="product-ftr--cart text-center">
                      <div className="product-add-btncart me-2 me-lg-4">
                        <span onClick={removeProduct} className="item-btn-wgt">-</span>
                        <input type="text" value={productCount} className="input-add-product form-control" />
                        <span onClick={addProduct} className="item-btn-wgt">+</span>
                      </div>
                      <div onClick = {() => onAddToCart(productDetails, productCount)} className="nv-cart-button">
                        <button type="button" className="btn cart-btn-cart">Add To Cart</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="dtl-infowap pt-4 pt-md-0">
                    <h2 className="title-product-head">{productDetails.title ? productDetails.title.en : ''}</h2>
                    <p className="short-disc-dtls">{productDetails.description ? productDetails.description.en : ''}</p>
                    <div className="price-item-dtls-prd">
                      <span className="txt-price-dtls cross-price">₹{productDetails.prices ? productDetails.prices.originalPrice : ''}</span><span className="txt-price-dtls actual-price">₹{productDetails.prices ? productDetails.prices.price : ''}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Footer />
      </div>

    </>
  );
};
export default Dashboard;
